import { Currency } from '#src/__generated__/globalTypes.ts';
import { useCurrentUserContext } from '#src/contexts/currentUser/index.ts';

import { useCryptoBalance } from './useCryptoBalance.ts';
import { useFiatBalance } from './wallets/useFiatBalance.ts';

export const useCurrentUserCurrencies = () => {
  const { currency } = useCurrentUserContext();
  const { fiatCurrency, fiatCurrencySymbol } = useFiatBalance();
  const { cryptocurrency, cryptocurrencySymbol } = useCryptoBalance();

  return {
    currency,
    mainCurrency: currency === Currency.ETH ? cryptocurrency : fiatCurrency,
    mainCurrencySymbol:
      currency === Currency.ETH ? cryptocurrencySymbol : fiatCurrencySymbol,
    fiatCurrency,
    cryptocurrency,
    fiatCurrencySymbol,
    cryptocurrencySymbol,
  };
};
